'use client'

import { cn } from "@/lib/utils"
import { useTranslations } from 'next-intl'

interface HeroChromeProps {
  backgroundImage: string;
  backgroundImageAuthor?: string;
  storeName: string;
  children: React.ReactNode;
  className?: string;
}

export function HeroChrome({
  backgroundImage,
  backgroundImageAuthor,
  storeName,
  children,
  className
}: HeroChromeProps) {
  const t = useTranslations('Store.HeroChrome')

  const ariaLabel = backgroundImageAuthor
    ? t('ariaLabelWithAuthor', { storeName, author: backgroundImageAuthor })
    : t('ariaLabel', { storeName })

  return (
    <div
      className={cn("relative bg-cover bg-center py-12 md:py-24", className)}
      style={{
        backgroundImage: `url("${backgroundImage}")`,
        backgroundBlendMode: 'overlay',
        backgroundColor: 'rgba(0,0,0,0.5)'
      }}
      role="banner"
      aria-label={ariaLabel}
    >
      {children}
      {backgroundImageAuthor && (
        <div className="absolute bottom-2 right-2 text-xs text-white opacity-70">
          {t('photoBy', { author: backgroundImageAuthor })}
        </div>
      )}
    </div>
  )
} 